import AnalyticsProvider from '@jetshop/core/analytics/AnalyticsProvider';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
// Cookies
import { CookiesProvider } from 'react-cookie';
// Metadata
import { HelmetProvider } from 'react-helmet-async';
import AuthProvider from '../components/AuthContext/AuthProvider';
import { BreakpointProvider } from '../components/BreakpointProvider';
// React Router DOM
import { ChannelProvider } from '../components/ChannelContext/';
import { ConfigProvider } from '../components/ConfigProvider';
import { PreviewProvider } from '../components/PreviewContext';
import { NotificationsProvider } from '../components/Notifications';
const SharedTree = ({ activeBreakpoint, cookies, helmetContext, releware, client, config, authHandler, Router, routerProps, children, channelHandler, previewHandler }) => {
    return (React.createElement(ConfigProvider, { config: config },
        React.createElement(NotificationsProvider, null,
            React.createElement(CookiesProvider, { cookies: cookies },
                React.createElement(HelmetProvider, { context: helmetContext },
                    React.createElement(BreakpointProvider, { value: activeBreakpoint },
                        React.createElement(ApolloProvider, { client: client },
                            React.createElement(ChannelProvider, { config: config, channelHandler: channelHandler },
                                React.createElement(AnalyticsProvider, { releware: releware },
                                    React.createElement(PreviewProvider, { previewHandler: previewHandler },
                                        React.createElement(Router, Object.assign({ basename: channelHandler.getChannelBasename() || undefined }, routerProps),
                                            React.createElement(AuthProvider, { auth: authHandler }, children))))))))))));
};
export default SharedTree;
//# sourceMappingURL=SharedTree.js.map